import React, { FC, Fragment } from "react";
import { Colors } from "../../styles";
import { MenuItem as MUIMenuItem } from "@material-ui/core";

import { TextField, makeStyles, withStyles, createStyles } from "@material-ui/core";
import { TextFieldProps } from "@material-ui/core/TextField";

const textFieldStyles = makeStyles({
    root: error => ({
        marginTop: 7,
        width: "50%",
        height: 56,
        zIndex: 3,
        borderRadius: 28,
        color: Colors.mellowYellow,

        "& .MuiSelect-select:focus": {
            borderRadius: 28,
        },

        "& .MuiSelect-icon": {
            fill: "transparent",
        },

        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderRadius: 28,
                border: `"1px" solid ${error ? Colors.radiantRed : Colors.anthracite25}`,
            },
            "&:hover fieldset": {
                borderColor: error ? Colors.radiantRed : Colors.mellowYellow,
                borderWidth: "1px",
            },
            "&.Mui-focused fieldset": {
                borderColor: error ? Colors.radiantRed : Colors.blueBright,
                backgroundColor: Colors.white,
                borderWidth: "1px",
            },
        },
    }),
});

export const MenuItem = withStyles({
    root: {
        fontFamily: "innogyWEB",
        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        letterSpacing: "normal",
        color: Colors.anthracite,
        borderBottom: `1px solid ${Colors.anthracite25}`,
        marginLeft: 20,
        marginRight: 20,

        "&.MuiListItem-gutters": {
            paddingLeft: 0,
            paddingRight: 0,
        },
        "&:last-child": {
            borderWidth: 0,
        },
    },
})(MUIMenuItem);

const useStyles = makeStyles(() =>
    createStyles({
        icon: {
            marginRight: 17,
            zIndex: 1,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath" +
                " fill-rule='evenodd' transform='translate(-348 -16)' clip-rule='evenodd' d='M360 34.64c-.16 0-.32-.04-.48-.12l-11.4-11.4c-.08-.08-.12-.22-.12-.42 0-.2.06-.36.18-.48s.26-.16.42-.12c.16.04.32.1.48.18L360 33.2l10.92-10.92c.16-.16.32-.24.48-.24.16 0 .3.06.42.18s.18.28.18.48c0 .2-.04.34-.12.42l-11.4 11.4c-.16.08-.32.12-.48.12z' fill='%23f59b00'/%3E%3C/svg%3E\")",
        },
        selectRoot: {
            fontFamily: "innogyWEB",
            fontSize: 22,
            fontWeight: 300,
            fontStretch: "normal",
            fontStyle: "normal",
            letterSpacing: "normal",
            color: Colors.anthracite,
            zIndex: 2,
            borderRadius: 28,
            paddingLeft: 20,
        },
        noBorder: {
            border: "none",
        },
        menuPaper: {
            marginTop: 5,
            boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.1)",
            border: "solid 1px #dddddd",
            backgroundColor: Colors.white,
            align: "center",
        },
    }),
);

type Props = TextFieldProps & {
    children: JSX.Element | JSX.Element[];
    error?: boolean;
};

export const Select: FC<Props> = ({ children, ...other }: Props) => {
    const classes = useStyles();
    const textFieldClasses = textFieldStyles(other.error);

    return (
        <Fragment>
            <TextField
                {...other}
                select
                variant="outlined"
                className={textFieldClasses.root}
                SelectProps={{
                    displayEmpty: true,
                    style: { height: 56 },
                    classes: {
                        icon: classes.icon,
                        root: classes.selectRoot,
                        select: classes.selectRoot,
                    },
                    MenuProps: {
                        classes: { paper: classes.menuPaper },
                        getContentAnchorEl: null,
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                    },
                    error: other.error,
                }}
            >
                {children}
            </TextField>
        </Fragment>
    );
};
